// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#comment-post{max-height:103px;resize:none;overflow-y:scroll;outline:none;font-size:14px;line-height:150%}.dosiin_action-comment{overflow:hidden;border-radius:30px!important}#comment-post::-moz-placeholder{line-height:21px}#comment-post:-ms-input-placeholder{line-height:21px}#comment-post::placeholder{line-height:21px}.comment-post::-webkit-scrollbar{display:none}.no-login{padding:5px 16px}", ""]);
// Exports
module.exports = exports;
